import React from "react";
import { connect } from "react-redux";

import { getPaymentInstallment, getPaymentInstallmentSelectedPrice } from "state/school_money/selectors";
import { removePaymentInstallmentFromBasket } from "state/school_money/actions";

import Currency from "components/Currency";
import Date from "components/Date";
import RemoveButton from "components/school_money/RemoveButton";

import "./PaymentInstallment.css";

class PaymentInstallment extends React.Component {
  
  render() {
    
    const { selectedPrice, installment } = this.props;
    
    return (
      <tr className="payment-basket-item-installment">
        <td className="payment-basket-item-installment__due-date">
          <Date date={installment.dueDate} />
        </td>
        <td className="payment-basket-item-installment__price">
          <Currency className="payment-basket-item-installment__price-amount" amount={selectedPrice} />
        </td>
        <td className="payment-basket-item-installment__button">
          <RemoveButton className="payment-basket-item-installment__remove-button" onClick={this.props.remove} />
        </td>
      </tr>
    )
    
  }
  
}

export default connect(
  (state, { paymentID, installmentNumber }) => ({
    installment: getPaymentInstallment(state, paymentID, installmentNumber),
    selectedPrice: getPaymentInstallmentSelectedPrice(state, paymentID, installmentNumber)
  }),
  (dispatch, { paymentID, installmentNumber }) => ({
    remove: () => dispatch(removePaymentInstallmentFromBasket(paymentID, installmentNumber))
  })
)(PaymentInstallment);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/payment/PaymentInstallment.js